import React from 'react';

interface ToggleSignUpButtonProps {
    isSignUp: boolean;
    setIsSignUp: any;
}

const ToggleSignUpButton: React.FC<ToggleSignUpButtonProps> = ({ isSignUp, setIsSignUp }) => {
    return (
        <p className="mt-6 text-center text-gray-600">
            {isSignUp ? 'Already have an account?' : "Don't have an account?"}
            <button onClick={() => setIsSignUp(!isSignUp)}
                    className="text-cyan-800 ml-2 hover:underline">
                {isSignUp ? 'Sign In' : 'Sign Up'}
            </button>
        </p>
    );
};

export default ToggleSignUpButton;
